export const SHEETS_MACHINES_WITH_SCANNERS = ['Laser', 'Horizon1']
// map user selection to filtered job locations
export const SHEETS_MACHINES_NAME_MAPPING  = {
    'LZR001' : 'Laser',
    'HRZ001' : 'Horizon1',
    'HRZ002' : 'Horizon2',
    'HRZ003' : 'Horizon3',
    'HRZ004' : 'Horizon4',
    'HRZ005' : 'Horizon5',
    'HRZ006' : 'Horizon6',
    'HRZ007' : 'Horizon7',
    'HRZ008' : 'Horizon8',
    'HRZ009' : 'Horizon9',
    'LZR002' : 'Laser',
}
export const DB_ID_TO_MACHINE_NAME_MAPPING = {
    '1' : 'Horizon 1',
    '2' : 'Horizon 2',
    '3' : 'Horizon 3',
    '4' : 'Laser 1',
    '5' : 'Horizon 4',
    '6' : 'Horizon 5',
    '7' : 'Horizon 6',
    '8' : 'Horizon 7',
    '9' : 'Horizon 8',
    '10': 'Laser 2'
}
export const OA_MACHINES_WITH_SCANNERS = []
export const OA_MACHINES_NAME_MAPPING  = {}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/existingmachines.ts